import React from 'react'
import Modal from 'react-modal'
import styles from './PrintModal.scss'
import cs from 'classnames'
import HtmlContent from './HtmlContent'
import HtmlContentStyle from './HtmlContent.scss'
import nesProp from 'nested-property'
import {connect} from 'react-redux'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

@connect((state) => ({
    printModal: state.app.printModal
}))
export default class PrintModal extends React.Component {
	static propTypes = {
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string,
	    options: React.PropTypes.object,
    }
    constructor(props) {
        super(props)
        this.state = {templates: null}
    }

    /**
     * This function opens a print window with the modal content
     */
    onPrint() {
        const {printModal} = this.props
        const theWindow = window.open('', 'PRINT', 'height=600,width=800')
        theWindow.document.write('<html><head><title>' + printModal.title  + '</title>')
        theWindow.document.write('<style>')
        // this line of css made from HtmlContent.scss -> replace variables -> convert to css -> minify
        theWindow.document.write(".content ol,.content p,.content ul{margin:0 0 10px;color:#404548}.content em{font-style:italic}.content strong{font-weight:700}.content p.highlight{font-weight:700}.content p.bullet{padding-left:1em;text-indent:-1em}.content p.bullet::before{content:'•';padding-right:.5em}.content ol,.content ul{padding-left:20px}.content ol li,.content ul li{margin-left:1em}.content ol{list-style-type:decimal}.content ul{list-style-type:circle}.content h1{font-size:1.4em}.content h2{font-size:1.2em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{font-weight:lighter;margin-top:1em;margin-bottom:.5em}.content hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.content blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}.content pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}.content pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}")
        theWindow.document.write('</style>')
        theWindow.document.write('</head><body class="content">')
        theWindow.document.write(printModal.message)
        theWindow.document.write('</body></html>')
        theWindow.document.close() // IE >= 10
        theWindow.focus() // IE >= 10
        theWindow.print()
        // theWindow.close()

        return true;
    }

	render() {
        const {printModal, onCancel, onConfirmation, cancelLabel, confirmationLabel,
            options} = this.props
        let hasCancelButtonStyle = nesProp.get(options, 'hasCancelButtonStyle')
        let noButtons = nesProp.get(options, 'noButtons')
        let showPrintButton = nesProp.get(options, 'showPrintButton')
        let printButtonLabel = nesProp.get(options, 'printButtonLabel') || ""

        let modalId = nesProp.get(printModal, "modalId")
        let isOpen = nesProp.get(printModal, modalId+"IsOpen")

        return (
            <div>
              <Modal
                    isOpen={isOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div id={"printerId"}>
                        <div className={styles.title}>{printModal && printModal.title}</div>
                        <div className={styles.contentWrapper}>
                            <div className={styles.content}>
                                {printModal &&
                                    <HtmlContent className="" content={printModal.message}/>
                                }
                            </div>
                            <div className={styles.buttons}>

                                {!noButtons &&
                                <div
                                    onClick={onCancel}
                                    className={cs((hasCancelButtonStyle ? styles.cancel : ""))}
                                >
                                    {cancelLabel}
                                </div>}

                                {!noButtons && showPrintButton && <div
                                    onClick={() => {this.onPrint(printModal)}}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {printButtonLabel}
                                </div>}

                                {!noButtons &&
                                <div
                                    onClick={onConfirmation}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {confirmationLabel}
                                </div>}
                            </div>
                        </div>
                    </div>
                </Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./elements/PrintModal.jsx